// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__8zpMx","success":"icon_success__d-diM","error":"icon_error__3zpWj","cursor":"icon_cursor__d3kaF"};